import { Record } from 'immutable';

export const ElementValidationError = Record({
  responseElementId: null,
  errorMessage: null
});

export const ValidationResult = Record({
    errors: ElementValidationError({}),
    isValid: true
})



// WEBPACK FOOTER //
// src/responses/element-validation-result.js